<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <div class="custom-container">

      <div class="form-wrapper">
        
        <div class="d-flex justify-content-center mt-3">
          <span class="header header-4">{{primaryResultText}}</span>
        </div>

        <div class="d-flex justify-content-center mt-2">
          <span class="header header-4">{{secondaryResultText}}</span>
        </div>

        <div class="form row mx-md-5 pt-3 pb-5 px-3 px-md-5">

          <form class="col-12" novalidate>

            <div class="d-flex justify-content-center">
              <span class="header header-4">Informações de contacto</span>
            </div>

            <div class="form-row">
              <div class="col-12">
                <label class="custom-label" for="name">{{$t('form.name')}}</label>
                <input v-model="form.data.name" 
                      id="name"
                      type="text"
                      :placeholder="$t('form.placeholders.name')"
                      maxlength="255" 
                      class="form-control" 
                      :class="{'is-invalid': errors.has('name')}"
                      @focus="errors.clear('name')"
                  >
                <div class="invalid-feedback" v-show="errors.has('name')">
                  {{errors.get('name')}}
                </div>
              </div>    
            </div>

            <div class="form-row">
              <div class="col-12">
                <label class="custom-label" for="email">{{$t('form.email')}}</label>
                <input v-model="form.data.email" 
                      id="name"
                      type="text"
                      :placeholder="$t('form.placeholders.email')"
                      maxlength="255" 
                      class="form-control" 
                      :class="{'is-invalid': errors.has('email')}"
                      @focus="errors.clear('email')"
                  >
                <div class="invalid-feedback" v-show="errors.has('email')">
                  {{errors.get('email')}}
                </div>
              </div>    
            </div>

            <div class="form-row">
              <div class="col-12 mb-4 mb-md-0">
                <label class="custom-label" for="phone">{{$t('form.phone')}}</label>
                <input v-model="form.data.phone" 
                      id="phone" 
                      type="text" 
                      :placeholder="$t('form.placeholders.phone')"
                      maxlength="16"
                      class="form-control" 
                      :class="{'is-invalid': errors.has('phone')}"
                      @focus="errors.clear('phone')"
                  >
                <div class="invalid-feedback" v-show="errors.has('phone')">
                  {{errors.get('phone')}}
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-start">
              <span class="header header-6 header-start no-margin">Para visualizar os resultados detalhados do seu teste auditivo preencha o formulário acima e clique no botão de submissão.</span>
            </div>

          </form>
        </div>

        <div class="actions d-flex justify-content-center">
          <button type="button" :disabled="isSubmiting" class="button primary" :class="{'disabled': isSubmiting}" @click="submit">{{$t('actions.submit')}}</button>
        </div>   
      </div>
    </div>
  </div>
</template>
<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
  props: {
    hasHearingLoss: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    isSubmiting: {
      type: Boolean,
      required: true
    }
  },
  mounted: function () {
    // this.$ga.event({
    //   eventCategory: 'questionnaire',
    //   eventAction: 'questionnaire-score',
    //   eventLabel: 'Valor do questionário',
    //   eventValue: this.questionnaireScore
    // })
    this.form.data = JSON.parse(JSON.stringify(this.user))
  },
  data: function () {
    return {
      form: {
        data: {
          name: null,
          email: null,
          phone: null,
          birthdate: null,
          gender: null
        }
      }
    }
  },
  methods: {
    submit: function () {
      this.validateForm()

      if (this.formIsValid) {
        this.$emit('continue')
      }
    },
    validateForm: function () {
      let errors = {}

      if (this.form.data.name === null) {
        errors['name'] = 'O campo Nome é obrigatório'
      } else if (this.form.data.name.trim().length === 0) {
        errors['name'] = 'O campo Nome é obrigatório'
      } else if (this.form.data.name.trim().length > 255) {
        errors['name'] = 'O campo Nome não poderá ter mais de 255 carateres'
      }

      if (this.form.data.email === null) {
        errors['email'] = 'O campo Email é obrigatório'
      } else if (this.form.data.email.trim().length === 0) {
        errors['email'] = 'O campo Email é obrigatório'
      } else if (this.form.data.email.trim().length > 255) {
        errors['email'] = 'O campo Email não poderá ter mais de 255 carateres'
      } else if (!this.form.data.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
        errors['email'] = 'O campo Email não é um email válido' 
      }

      if (this.form.data.phone === null) {
        errors['phone'] = 'O campo Contacto é obrigatório'
      } else if (this.form.data.phone.trim().length === 0) {
        errors['phone'] = 'O campo Contacto é obrigatório'
      } else {
        const phoneNumber = parsePhoneNumberFromString(`+351${this.form.data.phone}`)
        if (!(phoneNumber && phoneNumber.isValid())) {
          errors['phone'] = 'Por favor forneça um contacto válido'
        }
      }

      this.errors.record(errors)
    }
  },
  computed: {
    primaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.hearing_loss.has_loss') : this.$t('results_stage.hearing_loss.ok')
    },
    secondaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.recommendations.schedule') : this.$t('results_stage.recommendations.yearly_test')
    },
    formIsValid: function () {
      return !this.errors.any()
    }
  },
  watch: {
    'form.data': function (value) {
      this.$emit('update:user', value)
    }
  }
}
</script>

<style scoped>

.hearing-loss-icon-box {
  padding: 0.75rem 2rem;
  color:#dc3545;
  border-right: solid 1px #d3d3d3;
}

.hearing-loss-icon-box i {
  font-size: 1.5rem;
}

.hearing-loss-message {
  padding: 0rem 2rem;
}

@media screen and  (max-width: 768px) {

  .hearing-loss-icon-box {
      border-right: none;
  }

  .hearing-loss-message {
    text-align: center;
  }
}

@media screen and  (min-width: 1196px) {

  .form-wrapper {
    margin: 2.5rem 22.5%;
  }

}

</style>